import { gql, useQuery } from "@apollo/client";

export const Renting = gql`
	query Renting($id: String) {
		renting(id: $id) {
			_id
			pricePerDay
			client
			machine
			status
			startedRent
			endedRent
			previsionEndingRent
		}
	}
`;
